import { useState, useEffect } from 'react';
import { url } from '../utils/config';
import Register from '../child_components/Register';
import Table from '../reusable_components/Table';
import Button from '../reusable_components/Button';
import { title, btnOneNoWidth } from '../utils/style';
import edit from '../assets/icons/edit.png'
import deleteIcon from '../assets/icons/delete.png'
import ConfirmationModal from '../reusable_components/ConfirmationModal';
import SetDefaultRate from '../modals/SetDefaultRate';
import { toast } from 'react-toastify';
import axios from 'axios';


function Technicians() {
    const [ deleteId, setDeleteId ] = useState(null)
    const [ showAddAndModifyTechnician, setShowAddAndModifyTechnician ] = useState(false);
    const [ showDefaultRate, setShowDefaultRate ] = useState(false);
    const [ action, setAction ] = useState('add')
    const [ technicianData, setTechnicianData ] = useState(null)
    const [ reloadTable, setReloadTable ] = useState(false)
    const [ technicians, setTechnicians ] = useState([])
    const [ defaultRate, setDefaultRate ] = useState(null)
    
    useEffect(() => {
        fetchTechnicians();
        fetchDefaultRate();
    }, [reloadTable]);

    // Fetch all technicians
    const fetchTechnicians = async () => {
        try {
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const { data } = await axios.get(`${url}/technicians`, { headers });
            if (data && data.data) {
                setTechnicians(data.data);
            }
        } catch (error) {
            console.error("Error fetching technicians:", error);
        }
    };

    // Fetch default hourly rate
    const fetchDefaultRate = async () => {
        try {
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const { data } = await axios.get(`${url}/default_technician_cost`, { headers });
            if (data && data.data) {
                setDefaultRate(data.data.value);
            }
        } catch (error) {
            console.error("Error fetching default rate:", error);
        }
    };

    // Handle technician update from edit form
    const handleTechnicianUpdate = (updatedTechnician) => {
        // Update the technician in the local state
        const updatedTechnicians = technicians.map(tech => {
            if (tech.id === updatedTechnician.id) {
                return updatedTechnician;
            }
            return tech;
        });
        setTechnicians(updatedTechnicians);
    };

    function toggleModify(data) {
        setTechnicianData(data);
        setAction('edit');
        setShowAddAndModifyTechnician(true);
    }

    function showAddTechnician() {
        // Clear any previous technician data
        setTechnicianData(null);
        setAction('add');
        setShowAddAndModifyTechnician(true);
    }

    async function deleteTechnician() {
        try {
            const reqUrl = url + '/technician/' + deleteId;
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const { data } = await axios.delete(reqUrl, { headers });
            toast.success(data.message, { autoClose: 3000 });
            
            // Remove the deleted technician from local state
            const updatedTechnicians = technicians.filter(tech => tech.id !== deleteId);
            setTechnicians(updatedTechnicians);
            
            setReloadTable(1 + Math.random());
        } catch (error) {
            toast.error(error?.response?.data?.message || error.message, { autoClose: 3000 });
        } finally {
            setDeleteId(null);
        }
    }

    const options = [
        {
            header: 'Name',
            render: (data) => { return data.firstName + ' ' + data.lastName },
            filterKey: 'firstName',
            width: "20%"
        },
        {
            header: 'Phone No.',
            key: 'phone',
            placeHolder: '+1 1234567890',
            width: "20%"
        },
        {
            header: 'Email Id',
            key: 'email',
            placeHolder: 'user@xyz.com',
            width: "20%"
        },
        {
            header: 'Status',
            render: (data) => 
                <span className="px-3 py-1 text-sm rounded-full bg-green-100 text-green-800">
                    {data.status || "Active"}
                </span>
            ,
            width: "10%"
        },
        {
            header: 'Hourly Cost',
            width: "10%",
            render: (data) => (
                <div className="text-center">
                    {data.hourlyCost ? 
                        `$${parseFloat(data.hourlyCost).toFixed(2)}` : 
                        `$${parseFloat(defaultRate).toFixed(2)} (Default)`
                    }
                </div>
            )
        },
        {
            header: 'Action',
            width: "10%",
            render: (data) => {
                return(
                    <div className="">
                        <button 
                            className={'bg-customOne p-2 rounded-full mr-4'}
                            onClick={() => toggleModify(data)}
                        >
                            <img src={edit} height={15} width={15} />
                        </button>
                        <button 
                            className={'bg-customOne p-2 rounded-full mr-4'}
                            onClick={() => setDeleteId(data.id)}
                        >
                            <img src={deleteIcon} height={15} width={15} />
                        </button>
                    </div>
                )
            }
        },
    ]
    const excludeFilter = ['Action', 'Status']

    return(
        <div className="p-4">
            {
                showAddAndModifyTechnician ? 
                <Register 
                    setShowForm={setShowAddAndModifyTechnician} 
                    reload={setReloadTable} 
                    data={technicianData} 
                    formType='technician' 
                    action={action}
                    onUpdateSuccess={handleTechnicianUpdate}
                /> : null
            }
            {
                deleteId && <ConfirmationModal title={'Technician'} setShowForm={setDeleteId} confirm={deleteTechnician} />
            }
            {
                showDefaultRate ? 
                <SetDefaultRate 
                    setShowModal={setShowDefaultRate} 
                    reload={setReloadTable} 
                /> : null
            }
            <div className={title}></div>
            <div className="flex justify-between items-center mb-4">
                <div className={title}>Technicians</div>

                {(
                    <div className="flex items-center justify-between">
                        <Button className={`${btnOneNoWidth} mr-2`} name={`Set Default Rate`} clickHandler={() => setShowDefaultRate(!showDefaultRate)} />
                        <Button className={`${btnOneNoWidth}`} name={`Add Technician`} clickHandler={() => showAddTechnician()} />
                    </div>
                )}
            </div>
            <Table 
                options={options} 
                url={url + '/technicians'} 
                pagination 
                excludeFilter={excludeFilter}
                reloadTable={reloadTable}
                noButton={true}
                data={technicians.length > 0 ? { data: technicians } : null}
            />
        </div>
    )
}

export default Technicians;